import { useMemo } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { shuffleArray } from '../../utils/arrayUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeedbackSurveyResponses = ({
  onSelectResponse,
  responses
}) => {
  const shuffledResponses = useMemo(() => shuffleArray(responses), [responses]);
  return /*#__PURE__*/_jsx(TFlex, {
    flexWrap: "wrap",
    gap: 10,
    paddingBlockEnd: "500",
    children: shuffledResponses.map((response, index) => {
      return /*#__PURE__*/_jsx(SelectableButton, {
        paddingInline: "300",
        paddingBlockEnd: "100",
        size: "xs",
        description: /*#__PURE__*/_jsx("b", {
          children: response
        }),
        onSelectedChange: event => onSelectResponse(response, event.target.value)
      }, index);
    })
  });
};